/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Customer Data Platform capability.
 */
export const CDP_CAPABILITY_STRINGS = {
  altTitle: `customer data platform`,
  dialogBlurb: `lets you build unified customer profiles.`,
  dialogBullet1: `Collect data in a governed way from web, mobile, CRM's, and any omnichannel.`,
  dialogBullet2: `Unify it to create accurate customer profiles in real time.`,
  dialogBullet3: `Use external tools to take further action on the insights from the CDP.`,
  subtitle: `Unify data from various sources and segment audiences for personalization.`,
  title: `Customer data platform`,
};
